/// <reference path="../../adpIntegration/sections/adpIntegration.commission.section.ts" />


module Meevo.Plugins.AdpWfnIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WfnCommissionSection extends Meevo.Plugins.AdpIntegration.CommissionSection {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            $translate: angular.translate.ITranslateService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Components.Busy.IBusyService,
            compensationSettingsEndPoint : string,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                $translate,
                noun,
                identityService,
                modalService,
                busyService,
                compensationSettingsEndPoint,
                sectionSecurityKey);
        }

        earningCodesWithName(): any {
            return this.model.adpEarningCodeList.filter(e => Model.Guard.isSomething(e.shortName || e.longName) && (e.shortName || e.longName).length > 0)
        }
    }
}